<template>
  <div
    class="clearVideoButton"
    @click="click"
  >
    <div class="icon">
      <iconfont
        class="normal"
        name="#icon12-12shanchu"
      ></iconfont>
      <iconfont
        class="hover"
        name="#icon12-12shanchujiaohu"
      ></iconfont>
    </div>
    <div>清空列表</div>
  </div>
</template>

<script>
export default {
  name: 'ClearVideoButton',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped lang="scss">
.clearVideoButton {
  color: #3e424c;
  margin-left: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #ffffff;
    box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);

    .hover {
      display: none;
    }
  }
  &:hover {
    .normal {
      display: none;
    }
    .hover {
      display: block;
    }
  }
}
@media screen and (max-width: 1600px) {
  .clearVideoButton {
    font-size: 12px;
    .icon {
      width: 26px;
      height: 26px;
      font-size: 10px;
    }
  }
}
@media screen and (min-width: 1600px) {
  .clearVideoButton {
    font-size: 14px;
    .icon {
      width: 30px;
      height: 30px;
      font-size: 12px;
    }
  }
}
</style>
